export const ticketTypes:Record<string,string>={bug:'באג',feature_request:"בקשת פיצ'ר",question:'שאלה',service_request:'בקשת שירות',billing:'חיוב',other:'אחר'}
export const ticketSeverities:Record<string,string>={critical:'קריטית',high:'גבוהה',normal:'רגילה'}

// Presentation only: preserve the original records and technical evidence.
export function ticketText(value:string){
 return value.replace(/(?<![\wא-ת])(ticket_type|סוג)\s*[:=]\s*(bug|feature_request|question|service_request|billing|other)\b/g,(_,label,key)=>`${label==='ticket_type'?'סוג':label}: ${ticketTypes[key]}`)
  .replace(/\bbug_severity\s*[:=]\s*(critical|high|normal)\b/g,(_,key)=>`חומרה: ${ticketSeverities[key]}`)
  .replace(/חומרה\s*[:=]\s*(critical|high|normal)\b/g,(_,key)=>`חומרה: ${ticketSeverities[key]}`)
  .replace(/(\[(?:שם|טלפון|מייל|מספר|סוד|כתובת|ארגון|קישור)\])(?=[א-תA-Za-z])/g,'$1 ')
}
export function cardText(value:string|undefined){
 return ticketText(value??'').replace(/\b[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}(?:-e\d+)?\b/gi,'מזהה טכני')
}
